import { queryOptions } from "@tanstack/react-query"

import { apiKey } from "@/lib/api/changes"
import { apiFetch } from "@/lib/api/client"
import type { ApiResource } from "@/lib/api/types"
import type { Home } from "@/types/home"

export const homeQueries = {
  /** Home: what needs you, what changed and what is coming up, worded by the API. */
  show: () =>
    queryOptions({
      queryKey: apiKey("/home"),
      queryFn: async ({ signal }) => {
        const { data } = await apiFetch<ApiResource<Home>>("/home", { signal })

        return data
      },
    }),
}
